import React, {useEffect, useRef, useState} from 'react';
import {useSearchParams} from "react-router";
import { Template } from "../../../components/template/template.jsx";
import "../../../css/style-report.css";
import "../../../css/input-date-time.css";
import {Card} from "../../../components/card/card.jsx";
import Content from "./components/content.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import {useQuery} from "@tanstack/react-query";
import VehicleTrafficService from "./components/utils/vehicle-traffic-service.js";
import InputSwitch from "../../../components/input/input-switch.jsx";

const VehicleTraffic = () => {
    const [searchParams] = useSearchParams();
    const externalData = searchParams.get("d");
    const externalDataParsed = JSON.parse(atob(externalData))

    const [title] = useState("Relatório de Pesquisa de passagem");
    const [headerSelected, setHeaderSelected] = useState(-1);
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(false);

    const printComponentRef = useRef(null);
    const [reloadReportTrigger, setReloadReportTrigger] = useState(0);
    const [currentTotal, setCurrentTotal] = useState(0);
    const [canPrint, setCanPrint] = useState(false);
    const [showMoreInformation, setShowMoreInformation] = useState(externalDataParsed?.showImagesMetadata ?? false)

    const { data: response, isLoading } = useQuery({
        queryKey: ['vehicle-traffic', externalData, showMoreInformation],
        queryFn: () => VehicleTrafficService.getVehicleTraffic(externalData, showMoreInformation),
        enabled: !!externalData,
    });

    useEffect(() => {
        setReportData(response?.result);
        setLoading(isLoading);
    }, [response, isLoading]);

    useEffect(() => {
        setCurrentTotal(reportData?.data?.length || 0);
    }, [reportData]);

    const reloadReport = () => {
        setReloadReportTrigger(prev => prev + 1);
        setCanPrint(false);
    };

    return (
        <div className={"flex"}>

            <Template isLoading={loading}>
                <Template.Header>
                    <div className="flex justify-between w-full">
                        <Template.Title browserTitle={`${title}`}>{title}</Template.Title>
                        <div className="flex gap-6">
                            <InputSwitch
                                id="show-more-information"
                                label="Exibir metadados"
                                checked={showMoreInformation}
                                onChange={setShowMoreInformation}
                                disabled={!reportData?.showimages || isLoading}
                                title={!reportData?.showimages ? "Disponível somente em relatórios com imagens" : ""}
                            />
                            <HeaderButtons
                                printable={true}
                                headerChange={true}
                                printComponentRef={printComponentRef}
                                reportData={reportData}
                                data={1}
                                setHeaderSelected={setHeaderSelected}
                                reloadable={currentTotal < (reportData?.total || 0)}
                                onReloadReport={reloadReport}
                                canPrint={canPrint}
                            />
                        </div>
                    </div>
                </Template.Header>
                <Template.Body></Template.Body>
            </Template>

            <Card className={`w-full h-fit mr-2 !ml-[-8px] mt-[61px] print:!mt-[-15px] transform`}>
                <Card.Body>
                    <div className={`flex-1 px-[20px] py-[5px]`}>
                        <Content reportData={reportData} entity={headerSelected} title={title} setLoading={setLoading} printComponentRef={printComponentRef} reloadReportTrigger={reloadReportTrigger} setCurrentTotal={setCurrentTotal} setCanPrint={setCanPrint} showMoreInformation={showMoreInformation}/>
                    </div>
                </Card.Body>
            </Card>

        </div>
    );
};

export default VehicleTraffic;